export default __webpack_public_path__ + "static/blank-card-cardboard-01a5bedebe4d205ffb5de77fe6c4b023.webp";